import type { SelectablePeopleTypes } from '@assembly-web/services';
import { type ReactNode, useMemo } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { RadioGroup } from '../../../DesignSystem/Inputs/RadioGroup';
import { BlockLabel } from './BlockLabel';

const messages = defineMessages({
  label: {
    defaultMessage: 'Choose who can be selected',
    id: 'GoSXyx',
  },
  everyone: {
    defaultMessage: 'Everyone in the company',
    id: 'ithfzX',
  },
  sameGroupAsPost: {
    defaultMessage: 'Same as the group of people who can post',
    id: '1fE/AV',
  },
  sameGroupAsView: {
    defaultMessage: 'Same as the group of people who can view posts',
    id: 'FYdp0P',
  },
  custom: {
    defaultMessage: 'Custom',
    id: 'Sjo1P4',
  },
});

type BlockParticipantsProps = {
  value: string;
  onValueChange: (value: string) => void;
};

export function BlockParticipants({
  onValueChange,
  value,
}: BlockParticipantsProps) {
  const { formatMessage } = useIntl();

  const options = useMemo(
    () =>
      [
        { label: formatMessage(messages.everyone), value: 'EVERYONE' },
        {
          label: formatMessage(messages.sameGroupAsPost),
          value: 'PARTICIPANTS',
        },
        { label: formatMessage(messages.sameGroupAsView), value: 'VIEWERS' },
        {
          disabled: true,
          label: formatMessage(messages.custom),
          value: 'CUSTOM',
        },
      ] satisfies {
        value: SelectablePeopleTypes;
        label: ReactNode;
        disabled?: boolean;
      }[],
    [formatMessage]
  );

  return (
    <div className="flex flex-col gap-2">
      <BlockLabel>{formatMessage(messages.label)}</BlockLabel>
      <RadioGroup.Root value={value} onValueChange={onValueChange}>
        {options.map(({ label, value, disabled }) => (
          <RadioGroup.Item key={value} value={value} disabled={disabled}>
            {label}
          </RadioGroup.Item>
        ))}
      </RadioGroup.Root>
    </div>
  );
}
